export default __webpack_public_path__ + "static/media/35.d40abc83.jpg";